import { render, staticRenderFns } from "./DragDrop.vue?vue&type=template&id=11309d28&scoped=true&"
import script from "./DragDrop.vue?vue&type=script&lang=js&"
export * from "./DragDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragDrop.vue?vue&type=style&index=0&id=11309d28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11309d28",
  null
  
)

export default component.exports